export default {
  name: 'BaseNavbar'
};